import {Color} from 'three';
// Restrained per-resident variation retains the original painted coat pattern.
const coats=[new Color(1,1,1),new Color(1,.985,.965),new Color(.960,.980,1)];
export function tintAuthoredCoat(material,animal){material.color?.multiply(coats[(animal.variant??0)%coats.length]);return material;}
